var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"opt-item"},[_c('div',{staticClass:"name"},[_c('TextOverTooltip',{attrs:{"content":_vm.data.customerName,"placement":"right"}})],1),_vm._v(" "),(_vm.data.customerTel)?_c('div',{staticClass:"tel"},[_vm._v(_vm._s(_vm.data.customerTel))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }